export default '/static/frontend/ReachDigital/12gobiking/dist/assets/americanexpress3-81c50812.svg'